<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      searchTip='请根据设备编号进行搜索'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='paginationConfig'
      methods-data='other_report'
      params>
      <div>
           <span class='left-table'>
          时间类型：
          <el-select v-model='date_type' placeholder='请选择' @change='dateTypeSelect'>
            <el-option
              v-for='item in dateTypeList'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </span>
        <span class='left-table'>机柜编号：</span>
        <el-input v-model='cabinet_id' placeholder='请输入机柜编号' style='width: 200px;' clearable></el-input>
        <span class='left-table'>时间范围：</span>
        <el-date-picker
          :picker-options='pickerOptions'
          v-model='findDateTime'
          type='datetimerange'
          align='right'
          start-placeholder='开始'
          end-placeholder='结止'
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>

        <span class='left-table'>
          订单类型：
          <el-select v-model='device_type' placeholder='请选择' @change='deviceTypeSelect'>
            <el-option
              v-for='item in deviceTypeList'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </span>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
        <span class='left-table'>
          <el-button icon='el-icon-download' @click='down'>下载报表</el-button>
        </span>
      </div>
    </icare-table>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { xlsx } from '@/utils/xlsx'

export default {
  name: 'get_refund_order',
  data() {
    return {
      // 日期时间范围在一个月以内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 31 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      sum_data: {},
      paginationConfig: {
        cabinet_id: null,
        start_time: '',
        end_time: ''

      },
      findDateTime: [],
      deviceTypeList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '充电仓位'
        },
        {
          value: '1',
          label: '充电插座'
        }
      ],
      dateTypeList: [
        {
          value: 'day',
          label: '按天统计'
        },
        {
          value: 'month',
          label: '按月统计'
        },
        {
          value: 'year',
          label: '按年统计'
        }
      ],
      cabinet_id: '',
      device_type: '',
      date_type: 'day',
      select_device_type: '',
      titleConfig: [
        {
          field: 'cabinet_id',
          title: '机柜编号',
          visible: true,
          fuc: function(title, item, row) {
            return row.cabinet_id == 0 ? '所有机柜' : row.cabinet_id
          }
        },
        {
          field: 'device_type',
          title: '订单类型',
          visible: true,
          fuc: val => {
            let v
            if (this.select_device_type == '' || this.select_device_type == undefined) {
              return '所属订单'
            } else {
              if (val == 1) {
                v = '<div >充电插座</div>'
              } else {
                v = '<div >充电仓位</div>'
              }
              return v
            }
          }
        },
        {
          field: 'create_time',
          title: '日期',
          visible: true,
          fuc: function(title, item, row) {
            return row.create_time
          }
        },
        {
          field: 'cash',
          title: '支付金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div style="color:#67C23A">0.00</div>' : '<div style="color: #67C23A">+' + (val / 100).toFixed(2) + '</div>'
          }
        },
        {
          field: 'cash_cnt',
          title: '支付笔数',
          visible: true,
          fuc: val => {
            return val
          }
        },
        {
          field: 'coupon',
          title: '代金券金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div >0.00</div>' : '<div style="color: #F56C6C">' + (val / 100).toFixed(2) + '</div>'
          }
        },
        {
          field: 'coupon_cnt',
          title: '代金券抵扣笔数',
          visible: true,
          fuc: val => {
            return val
          }
        },
        {
          field: 'refund_fee',
          title: '退款金额(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div>0.00</div>' : '<div style="color: #F56C6C">-' + (val / 100).toFixed(2) + '</div>'
          }
        },
        {
          field: 'refund_fee_cnt',
          title: '退款笔数',
          visible: true,
          fuc: val => {
            return val
          }
        },
        {
          field: 'amount',
          title: '实收收入(元)',
          visible: true,
          fuc: val => {
            return val == 0 ? '<div>0.00</div>' : '<div style="color: #409EFF">' + (val / 100).toFixed(2) + '</div>'
          }
        }
      ]
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    //this.findDateTime=this.getPastTime()
    this.paginationConfig.req_type = 'get_found_bill_list'
  },
  mounted() {
  },
  methods: {
    find() {
      this.paginationConfig.cabinet_id = parseInt(this.cabinet_id)
      this.select_device_type = this.paginationConfig.device_type
      if (this.findDateTime != null && this.findDateTime.length === 2) {
        this.paginationConfig.start_time = this.findDateTime[0]
        this.paginationConfig.end_time = this.findDateTime[1]
      } else {
        this.paginationConfig.start_time = ''
        this.paginationConfig.end_time = ''
      }
      this.$refs.table.refresh()
    },
    deviceTypeSelect(v) {
      this.paginationConfig.device_type = v
    },

    dateTypeSelect(v) {
      this.paginationConfig.date_type = v
    },
    down() {

      if (this.findDateTime == null || this.findDateTime.length !== 2) {
        this.$message.warning('所选时间范围不能大于31天')
        return
      }

      if (this.date_type == 'day') { //判断是否是一个月的数据
        var startDate = new Date(this.findDateTime[0]).getTime()
        var endDate = new Date(this.findDateTime[1]).getTime()
        if (endDate - startDate > 31 * 24 * 60 * 60 * 1000) {
          this.$message({
            message: '所选时间范围不能大于31天',
            type: 'warning'
          })
          return
        }
      }

      this.find()

      // this.$message.warning('敬请期待')
      //
      let str = JSON.stringify({
        cabinet_id:parseInt( this.cabinet_id),
        start_time:this.findDateTime[0],
        end_time: this.findDateTime[1],
        req_type: 'down_found_bill_list',
        device_type: this.device_type,
        date_type: this.date_type,
      })
      gateway({
        func: 'other_report',
        params: str
      }).then(res => {
       if (res.code == 0) {
          var time = new Date().getTime()

         var header = {
            cabinet_id: '机柜编号',
            device_type: '订单类型',
            create_time: '日期',
            cash: '支付金额(元)',
            cash_cnt: '支付笔数',
            coupon: '代金券金额(元)',
            coupon_cnt: '代金券抵扣笔数',
            refund_fee: '退款金额(元)',
            refund_fee_cnt: '退款笔数',
            amount: '实际收入(元)'
          }

          for (var i = 0; i < res.result.length; i++) {
            res.result[i].cabinet_id = (res.result[i].cabinet_id == 0 ? '所有机柜' : res.result[i].cabinet_id )
            res.result[i].device_type = (this.device_type=='' ? '所有订单': res.result[i].device_type == 0 ? '充电仓位' : '充电插座')
            res.result[i].cash = ((res.result[i].cash / 100).toFixed(2))
            res.result[i].coupon = ((res.result[i].coupon / 100).toFixed(2))
            res.result[i].refund_fee = ((res.result[i].refund_fee / 100).toFixed(2))
            res.result[i].amount = ((res.result[i].amount / 100).toFixed(2))
          }
          xlsx(res.result, header, (this.cabinet_id==0 ? '所有机柜':this.cabinet_id)+ '-资金账单-' + time)
        }
      })
    },
    // 获取过去几个月的时间
    getPastTime() {
      // 获取本月时间段datePicker使用
      const oDate = new Date()
      let year = oDate.getFullYear()
      let month = oDate.getMonth()
      let start, end
      if (month == 0) {
        year--
        start = new Date(year, 0, 1)
        end = new Date(year, 12, 31)
      } else {
        start = new Date(year, month, 1)
        end = new Date(year, month + 1, 0, 23, 59, 59)
      }
      return [start, end]
    }
  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
